import { useQuery } from "@tanstack/react-query";
import { api, throwIfError } from "../client";
import { fleetEqualizationKeys } from "../query-keys";
import type { EventId } from "@/types/identifiers";

export { fleetEqualizationKeys } from "../query-keys";

export function useFleetEqualization(eventId: EventId) {
  return useQuery({
    queryKey: fleetEqualizationKeys.byEvent(eventId),
    queryFn: async () => {
      const result = await api.GET(
        "/api/events/{event_id}/fleet-equalization",
        { params: { path: { event_id: eventId } } },
      );
      return throwIfError(result, "Failed to fetch fleet equalization");
    },
    enabled: !!eventId,
  });
}
